import {CategoryDto, ProductCreateDto, ProductImageDto, ProductUpdateDto} from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof, RichtextEditor} from "digimuth-components/dist";
import {Select} from "antd";
import ProductsImagesUploader from "../../components/fileUploader/productsImagesUploader";

const {Option} = Select;

export default function ProductModalForm(props: ProductModalProps) {
    const formItems: CrudFormItemProps[] = [
        {
            name: nameof<ProductCreateDto>("name"),
            label: "Nazwa",
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
        },
        {
            name: nameof<ProductCreateDto>("description"),
            label: "Opis",
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
            children: <RichtextEditor
                toolbar={{
                    options: ['inline', 'blockType', 'fontSize', 'list', 'history', "link"],
                    inline: {
                        options: ['bold', 'italic', 'monospace']
                    },
                    list: {
                        option: ['unordered', 'ordered']
                    },
                    link: {inDropdown: true},
                    history: {inDropdown: true}
                }}
            />
        },
        {
            name: nameof<ProductCreateDto>("wineVariety"),
            label: "Szczep wina"
        },
        {
            name: nameof<ProductCreateDto>("categoriesIds"),
            label: "Kategorie",
            children: <Select mode={"multiple"} defaultValue={props.initCategoryId}>
                {props.categories?.map(c => <Option key={c.id} value={c.id}>
                    {c.name}
                </Option>)}
            </Select>
        },
        {
            label: "Zdjęcia produktu",
            name: nameof<ProductCreateDto>("imagesIds"),
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
            children: <ProductsImagesUploader
                files={props.files}
                setFiles={props.setFiles}
                defaultFileList={props.productImages?.map((a: any) => ({
                        uid: a.id,
                        name: a.fileName,
                        originFileObj: a.originFileObj
                    })
                )}
                allFiles={props.productImages}
            />
        }
    ];

    return <CrudFormModal
        formProps={{labelCol: {span: 4, offset: 0}}}
        formItems={formItems}
        onSubmit={props.onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={"Zapisz"}
        modalCancelText={"Anuluj"}
        forceRender={true}
        destroyOnClose={true}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
        width={1000}
    />;
}

interface ProductModalProps {
    initialValues?: ProductCreateDto | ProductUpdateDto,
    isModalVisible: boolean,
    setModalVisibility: (isVisible: boolean) => any,
    onSubmit: (value: ProductCreateDto | ProductUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
    initCategoryId?: number[],
    categories: CategoryDto[],
    productImages?: ProductImageDto[],
    files: ProductImageDto[],
    setFiles: any,
}
